/* ลูกค้าแจ้ง RC ใหม่ */
import React, { useEffect, useState } from "react";
import { Form, Input, Modal, Radio, message } from "antd";
import FilePicker from "../components/ak/FilePicker";
import { RC_TYPES, RC_TYPE_HINT } from "../components/ak/rc";
import { Portal, perr } from "./portalApi";

export default function PortalRcNew({ open, projectCode, onClose, onDone }) {
  const [form] = Form.useForm();
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const type = Form.useWatch("rc_type", form);

  useEffect(() => {
    if (open) {
      form.resetFields();
      setFiles([]);
    }
  }, [open, form]);

  const save = async () => {
    const v = await form.validateFields();
    setBusy(true);
    try {
      const r = await Portal.createRc({ ...v, project_code: projectCode }, files);
      message.success("ส่งเรื่องแล้ว เจ้าหน้าที่จะติดต่อกลับ");
      onDone?.(r.data.data);
    } catch (e) {
      message.error(perr(e, "ส่งไม่สำเร็จ กรุณาลองใหม่"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} title="แจ้งขอเปลี่ยนแปลง (RC)" onCancel={onClose} onOk={save} okText="ส่งเรื่อง" cancelText="ยกเลิก" confirmLoading={busy} destroyOnClose className="pt-modal">
      <Form form={form} layout="vertical" initialValues={{ rc_type: RC_TYPES[0] }} requiredMark={false}>
        <Form.Item name="rc_type" label="เรื่องที่ต้องการแจ้ง">
          <Radio.Group className="pt-type-group">
            {RC_TYPES.map((t, i) => (
              <Radio.Button key={t} value={t}>
                {i + 1}. {t}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>
        {type && <div className="pt-type-hint">{RC_TYPE_HINT[type]}</div>}
        <Form.Item name="title" label="หัวข้อ" rules={[{ required: true, message: "กรอกหัวข้อสั้น ๆ" }]}>
          <Input maxLength={200} placeholder="เช่น ขอเพิ่มปลั๊กไฟห้องนอนใหญ่ 2 จุด" />
        </Form.Item>
        <Form.Item name="detail" label="รายละเอียด">
          <Input.TextArea rows={4} maxLength={4000} placeholder="อธิบายเพิ่มเติม ตำแหน่ง ขนาด สี ฯลฯ" />
        </Form.Item>
      </Form>
      <div className="pt-label">แนบไฟล์ (ถ้ามี) — รูปถ่าย, ภาพสเก็ตช์, PDF</div>
      <FilePicker value={files} onChange={setFiles} compact />
    </Modal>
  );
}
